import {MenuModel} from '@shared/components/menu';
import {PermissionEnum} from '@services/permission';

export const DASHBOARD_ROUTE_KEY = '/dashboard';
export const LANGUAGE_DASHBOARD_ROUTE_KEY = '/language-dashboard';

export const MENU_LIST: MenuModel[] = [
  {
    item: 'Home',
    icon: 'home',
    iconClass: 'material-icons-outlined',
    routerLink: '/home',
    isHidden: false
  },
  {
    item: 'Campaigns',
    icon: 'waves',
    iconClass: 'material-icons-outlined',
    routerLink: '/campaigns',
    permission: PermissionEnum.Campaign.Index,
    isHidden: false
  },
  {
    item: 'Briefs',
    icon: 'assignment',
    iconClass: 'material-icons-outlined',
    routerLink: '/briefs',
    isHidden: false
  },
  {
    item: 'My approvals',
    icon: 'assignment_turned_in',
    iconClass: 'material-icons-outlined',
    routerLink: '/approvals',
    isHidden: false
  },
  {
    item: 'Asset archive',
    icon: 'folder',
    iconClass: 'material-icons-outlined',
    routerLink: '/asset-archive/',
    isHidden: false
  },
  {
    item: 'Company profile',
    icon: 'work_outline',
    iconClass: 'material-icons-outlined',
    routerLink: '/company',
    permission: PermissionEnum.Company.ViewInformation,
    isHidden: false
  },
  {
    item: 'Manage companies',
    icon: 'business_center',
    iconClass: 'material-icons-outlined',
    routerLink: '/manage-companies/',
    permission: PermissionEnum.Company.Index,
    isHidden: false
  },
  {
    item: 'Languages',
    icon: 'bar_chart',
    iconClass: 'material-icons-outlined',
    routerLink: LANGUAGE_DASHBOARD_ROUTE_KEY,
    permission: PermissionEnum.Reports.View,
    isHidden: false
  },
  {
    item: 'Languages [Beta]',
    icon: 'bar_chart',
    iconClass: 'material-icons-outlined',
    routerLink: '/language-dashboard-beta',
    permission: PermissionEnum.Reports.View,
    isHidden: false
  },
  {
    item: 'Dashboard',
    icon: 'bar_chart',
    iconClass: 'material-icons-outlined',
    routerLink: DASHBOARD_ROUTE_KEY,
    permission: PermissionEnum.Reports.View,
    isHidden: false
  },
  {
    item: 'Notifications',
    icon: 'notifications',
    iconClass: 'material-icons-outlined',
    routerLink: '/notifications',
    isHidden: false
  }
];
